import { useState } from "react";

import { Popover } from "antd";

import { ToolbarButton } from "components/base";
import { XdaLabelSpacing_Icon } from "components/icons";

import XdaSpacingOptions from "./XdaSpacingOptions";

// Spacing Class controls (EVA-163). Same popover shell as XdaRadiusToggle —
// click to open, options render inside — so the two panels behave identically.
//
// ICON: the asset supplied for this ticket (EVA-163 AC: "design to be done and
// consulted with Amy") — a label tag with the four-way spacing arrows, drawn
// with `currentColor` so it inherits the toolbar button's active/hover states
// like every other icon in this row.
function XdaSpacingToggle() {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={<XdaSpacingOptions />}
      open={visible}
      onOpenChange={(v) => setVisible(v)}
      trigger="click"
      placement="bottomRight">
      <ToolbarButton
        icon={<XdaLabelSpacing_Icon />}
        isMenuButton={true}
        active={false}
        overflowLabel={"Spacing"}
        tooltipText={"Spacing Class Options"}
        styleKey="xdaToolbar"
      />
    </Popover>
  );
}

export default XdaSpacingToggle;
